import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import "../styles/Singlequran.css"; // ملف CSS جديد للتصميم

function QuranDetails() {
  const { QuranID } = useParams(); // الحصول على رقم السورة من الرابط
  const [qurandetail, setQurandetail] = useState({});
  const [ayahs, setAyahs] = useState([]);
  const [sound, setsound] = useState(""); // رابط الصوت
  const [tafser, settafser] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false); // تتبع حالة الصوت
  const audioRef = useRef(null); // مرجع عنصر الصوت

  // جلب تفاصيل السورة
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.alquran.cloud/v1/surah/${QuranID}`
        );
        setQurandetail(response.data.data);
        setAyahs(response.data.data.ayahs);
      } catch (error) {
        console.error("Error fetching Quran details:", error);
      }
    };
    fetchData();
  }, [QuranID]);

  // جلب الصوت
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.quran.com/api/v4/chapter_recitations/7/${QuranID}`
        );
        setsound(response.data.audio_file.audio_url); // الصوت الأول
      } catch (error) {
        console.error("Error fetching Quran sound:", error);
      }
    };
    fetchData();
  }, [QuranID]);

  // تفسير السوره
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://quranenc.com/api/v1/translation/sura/arabic_moyassar/${QuranID}`
        );
        settafser(response.data.result);
      } catch (error) {
        console.error("Error fetching Quran Tafser:", error);
      }
    };
    fetchData();
  }, [QuranID]);

  // تشغيل/إيقاف الصوت
  const toggleAudio = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    } else {
      alert("الصوت غير متوفر حالياً.");
    }
  };

  return (
    <div className="quran-details">
      <h1 className="sura-name">{qurandetail.name}</h1>
      <div className="controls">
        <button className="play-audio" onClick={toggleAudio}>
          {isPlaying ? "⏸ إيقاف مؤقت" : "▶ تشغيل الصوت"}
        </button>
        <button
          // className="info-button"
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
        >
          تفسير السورة
        </button>
        <div
          style={{ color: "black", width: "100%" }}
          className="modal fade restafser"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content ">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  تفسير الآيات
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {tafser.map((taf) => {
                  return (
                    <>
                      <h2>{taf.arabic_text} :</h2>
                      <p style={{ fontWeight: "bold", color: "dimgray" }}>
                        {taf.translation}
                      </p>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <audio ref={audioRef} src={sound} /> {/* عنصر الصوت */}
      <div className="ayahs-container">
        <p style={{ fontSize: "50px", marginTop: "-30px" }}>
          بِسۡمِ ٱللَّهِ ٱلرَّحۡمَـٰنِ ٱلرَّحِیمِ
        </p>
        {ayahs.map((ayah, index) => (
          <div key={ayah.number} className="ayah">
            <p>
              {ayah.text.replace(
                "بِسۡمِ ٱللَّهِ ٱلرَّحۡمَـٰنِ ٱلرَّحِیمِ",
                ""
              )}
            </p>
            <span className="ayah-number">﴿{index + 1}﴾</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuranDetails;
